// Period keys understood by /portfolio/performance and /performance/dashboard.
export const TIME_RANGES = [
  { value: '1w', label: '1S' },
  { value: '1m', label: '1M' },
  { value: '3m', label: '3M' },
  { value: '6m', label: '6M' },
  { value: 'ytd', label: 'YTD' },
  { value: '1y', label: '1A' },
  { value: 'all', label: 'Max' },
];
